import { render, staticRenderFns } from "./PodcastCard.vue?vue&type=template&id=8864a154"
import script from "./PodcastCard.vue?vue&type=script&lang=js"
export * from "./PodcastCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports